module.exports = __webpack_public_path__ + "img/about-us-02.da9169df.webp";